import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Project } from '../../../../models/project';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActiveModal } from '../../../../core/modal.service';
import { FileUploader } from 'ng2-file-upload';
import { Auth } from '../../../../auth/auth.service';
import { ClrWizard } from '@clr/angular';
import { ObjectImportService } from '../../../object-import.service';
import { OptionService } from '../../../../shared/option.service';

@Component({
  selector: 'cw-import-objects-modal',
  templateUrl: './import-objects-modal.component.html',
  styleUrls: ['./import-objects-modal.component.scss'],
  providers: [
    ObjectImportService
  ]
})
export class ImportObjectsModalComponent implements OnInit {
  form: FormGroup;
  project: Project;
  opened: boolean;
  uploader: FileUploader = new FileUploader({});
  hasBaseDropZoneOver: boolean;
  errorResponse: string;
  @ViewChild('uploadEl') uploadElRef: ElementRef;
  @ViewChild("wizard") wizard: ClrWizard;

  headings: any;
  columns = [
    { key: '_', name: '-' },
    { key: 'number', name: 'Nummer' },
    { key: 'status', name: 'Status' },
    { key: 'floor_number', name: 'Våning' },
    { key: 'living_area', name: 'Storlek' },
    { key: 'price', name: 'Pris' },
    { key: 'monthly_fee', name: 'Avgift' },
    { key: 'rooms', name: 'Rum' }
  ];

  filename: string;
  objects: any[];
  statuses: string[];
  configForm: FormGroup;

  constructor(private fb: FormBuilder,
              private auth: Auth,
              private optionService: OptionService,
              private service: ObjectImportService,
              private modal: ActiveModal) {
    this.form = fb.group({});

    this.configForm = fb.group({
      mappings: fb.array([]),
      statuses: fb.group([])
    });

    this.configForm.get('mappings').valueChanges.subscribe(() => {
      console.log('apa');
      this.updateMappings();
    });

    this.uploader.onBeforeUploadItem = (item) => {
      this.errorResponse = null;
      item.withCredentials = false;
      this.uploader.authToken = 'Bearer ' + this.auth.getToken();
    };

    this.uploader.onAfterAddingFile = f => {
      console.log(this.uploader);
      this.uploader.uploadAll();
      // this.uploadElRef.nativeElement.value = '';
    };

    this.uploader.onCompleteItem = (item, response, status) => {
      if (status !== 200) {
        this.errorResponse = 'Fel vid uppladdning';
        return;
      }

      let json = JSON.parse(response);
      this.filename = json.filename;
      this.headings = json.headings;
      this.uploader.clearQueue();
      this.createFieldsForm();
      this.wizard.forceNext();
    };
  }

  ngOnInit() {
  }

  updateMappings() {
    const data = this.mappingsForm.value;
    this.service.setMappings(this.project, this.filename, data)
      .subscribe(data => {
        const needsUpdate = this.statuses !== data.statuses;
        this.statuses = data.statuses;

        if (needsUpdate) {
          this.createConfigForm();
        }
        //this.wizard.forceNext();
      });
  }

  onConfigCommit() {
    if (!this.configForm.valid) {
      return;
    }
    const data = this.configForm.value;
    console.log(data);
    this.service.configure(this.project, this.filename, data)
      .subscribe(data => {
        this.objects = data.rows;
        this.createConfigForm();
        this.wizard.forceNext();
      });
  }

  onImportCommit() {
    this.service.import(this.project, this.filename, this.objects)
      .subscribe(ok => {
        this.wizard.finish();
      });

  }


  init(project: Project) {
    this.project = project;
    this.opened = true;
    this.uploader.setOptions({
      url: `${this.project.url}/object-import/upload`
    })
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }


  close() {
    this.modal.dismiss();
  }

  get uploadInProgress() {
    return this.uploader.isUploading;
  }

  private createConfigForm() {
    Object.keys(this.statusesForm.controls).forEach(control => {
      this.statusesForm.removeControl(control);
    });

    this.configForm.setControl('statuses', this.fb.group({}));
    this.statuses.forEach(status => {
      this.statusesForm.addControl(status, this.fb.control(null, Validators.required));
    });
    console.log(this.statuses);
  }

  private createFieldsForm() {
    while (this.mappingsForm.length !== 0) {
      this.mappingsForm.removeAt(0)
    }
    this.headings.forEach(heading => {
      this.mappingsForm.push(this.fb.group(
        {
          column: this.fb.control(heading, null),
          field: this.fb.control('', null)
        }
      ));
    });
  }

  get objectStatuses() {
    return this.optionService.objectStatusOptions;
  }

  get mappingsForm() {
    return this.configForm.get('mappings') as FormArray;
  }

  get statusesForm() {
    return this.configForm.get('statuses') as FormGroup;
  }

  get statusControls() {
    return Object.keys(this.statusesForm.controls);
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail-objects/import-objects-modal/import-objects-modal.component.ts